import { useTranslation } from 'react-i18next';
import { type PayGatePaymentModuleSpecsFragment } from '../../../../../api/fragments/PayGatePaymentModuleSpecs';
import {
    type CreatePayGatePaymentModuleMutation,
    type CreatePayGatePaymentModuleMutationVariables,
    CreatePayGatePaymentModuleDocument,
} from '../../../../../api/mutations/createPayGatePaymentModule';
import { type PayGatePaymentModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import PayGatePaymentModulePage, { type PayGatePaymentModulePageProps } from '../../PayGatePaymentModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<PayGatePaymentModuleSpecsFragment, PayGatePaymentModuleSettings> = {
    PageComponent: ({ module }: PayGatePaymentModulePageProps) => <PayGatePaymentModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.PayGatePaymentModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreatePayGatePaymentModuleMutation, CreatePayGatePaymentModuleMutationVariables>({
                mutation: CreatePayGatePaymentModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
